import React from 'react';
import { $Loading } from './styles';
export const Loading = () => React.createElement($Loading, { color: 'inherit' });
